export default __webpack_public_path__ + "static/media/Treatment.e750ffb4.svg";